import { createTheme } from '@one-thd/sui-atomic-components';

const HouseStyleSecondaryLightKhaki = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

HouseStyleSecondaryLightKhaki.palette['--sui-palette-background-primary'] = '238 226 215';

export { HouseStyleSecondaryLightKhaki };